import { render, staticRenderFns } from "./regc.vue?vue&type=template&id=6b74314b&scoped=true"
import script from "./regc.vue?vue&type=script&lang=js"
export * from "./regc.vue?vue&type=script&lang=js"
import style0 from "./regc.vue?vue&type=style&index=0&id=6b74314b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b74314b",
  null
  
)

export default component.exports